export function emptyPlaceholder(value: string): string {
  return value.trim() ? value.trim() : '—';
}
